import logo from "./logo.svg";
import "./App.css";
import SignUp from "./components/account/SignUp";
import SignIn from "./components/account/SignIn";
import { Navigate, Route, Routes, useParams } from "react-router-dom";
import Recovery from "./components/account/Recovery";
import ResetPassword from "./components/account/ResetPassword";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { createContext, useEffect, useState } from "react";
import Product from "./dashboard/components/Product/Product";
import Vendor from "./dashboard/components/vendor/vendor";
import Setting from "./dashboard/components/setting/Setting";
import DashboardMain from "./dashboard/components/dashbaord_main/DashboardMain";
import Auth from "./ProtectedAuth/Auth";
import UserDashboard from "./userDashboard/userDashboard";
import Account from "./userDashboard/Account";
import Role from "./components/Role";
import NoAccessPage from "./NoAccessPage/NoAccessPage";
import UserProfile from "./userDashboard/userProfile";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import LandingPage from "./userDashboard/Landingpage";
import UserSignIn from "./userDashboard/userSignIn";
import UserSignUp from "./userDashboard/UserSignup";

function App() {
  let role;
  useEffect(() => {
    role = localStorage.getItem("role");
    console.log(role);
  }, [localStorage]);

  return (
    <div className="App overflow-x-hidden">
      <ToastContainer />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/signUp" element={<UserSignUp />} />
        <Route path="/signin" element={<UserSignIn />} />
        <Route path="/recovery" element={<Recovery />} />
        <Route path="/reset" element={<ResetPassword />} />
        <Route path="/no-access" element={<NoAccessPage />} />

        {/* user */}

        <Route path="userdashboard/:id" element={<UserDashboard />} />
        <Route
          path="account/:id"
          element={
            <Auth>
              <Account />
            </Auth>
          }
        />
        <Route
          path="userprofile/:id"
          element={
            <Auth>
              <UserProfile />
            </Auth>
          }
        />

        {/* Admin */}

        <Route
          path="dashboard/:id"
          element={
            <Auth>
              <Role>
                <DashboardMain />
              </Role>
            </Auth>
          }
        />
        {/* <Route
          path="vendor/:id"
          element={
            <Auth>
              <Role>
                <Vendor />
              </Role>
            </Auth>
          }
        /> */}
        <Route
          path="product/:id"
          element={
            <Auth>
              <Role>
                <Product />
              </Role>
            </Auth>
          }
        />
        <Route
          path="setting/:id"
          element={
            <Auth>
              <Role>
                <Setting />
              </Role>
            </Auth>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
